import { Injectable } from '@angular/core';
import {
  type IContextualAction,
  type IRoutable,
  StateBasedNavigationService,
} from '@principle-theorem/ng-principle-shared';
import { isPrincipleMention } from '@principle-theorem/principle-core/interfaces';
import { type IReffable } from '@principle-theorem/shared';

@Injectable()
export class LoadLabActionService implements IContextualAction {
  icon = 'open_in_new';
  name = 'View Lab';

  constructor(private _stateNav: StateBasedNavigationService) {}

  async do(lab: IRoutable | IReffable): Promise<void> {
    if (isPrincipleMention(lab)) {
      lab = lab.resource;
    }
    const uid: string = 'uid' in lab ? lab.uid : lab.ref.id;
    await this._stateNav.practice(['labs', uid]);
  }
}
